import React from 'react';
import {Col, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";

// Icons
import tennisBall from 'assets/images/icone_bola.svg';
import InfoButton from 'react-ionicons/lib/IosInformationCircleOutline';

// CSS Files
import './Card.css';

const Card = (props) => {
   const {t} = useTranslation();

   return (
      <Col xs={12}>
         <Col xs={12} className="card-games p-2 mb-3" onClick={props.onClick}>
            <Row className={"align-items-center"}>
               <Col xs={2} sm={1} className={"card-logo-container"}>
                  <img className="tennis-ball-logo tennis-ball-positioning" src={tennisBall} alt="tennis ball icon"/>
               </Col>
               <Col>
                  <p className={"league-name-text"}>{props.text}</p>
                  {props.clubs_label !== undefined && (
                     <p className="league-date-text card-league-date-text">{props.clubs_label}</p>
                  )}
               </Col>
               {props.showClubLocationInfo &&
                  <Col xs={3} sm={2} lg={3} md={2} onClick={props.showClubs}>
                     <Row className={"justify-content-center"}>
                        <InfoButton color="#AFFF55" fontSize="30px"/>
                     </Row>
                     <Row className={"justify-content-center"}>
                        <p className={"club-info"}>{t("registration_page.where")}</p>
                     </Row>
                  </Col>
               }
            </Row>
         </Col>
      </Col>

   );
};

export default Card;
